import { useEffect, useState } from "react"
import axios from "axios";
import { BACKEND_URL } from "../utils/constants";

export interface Account {
  id: number;
  code: string;
  name: string;
  reconcile?: boolean;
}

export const useAccounts = (companyId?: number | null) => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetcher = async (companyId?: number | null) => {
      if (companyId) {
        try {
          setLoading(true);
          const res = await axios.get<Account[]>(`${BACKEND_URL}/accounts?companyId=${companyId}`);
          setAccounts(res.data);
        } catch (error) {
          setError(error as Error);
        } finally {
          setLoading(false);
        }
      }
    }

    fetcher(companyId);
  }, [companyId])

  return { accounts, loading, error };
}
